'use strict';

const p2pmoney_ethereum_core_load = async () => {
	try {
		// shim
		if (window && !window.Buffer)
		window.Buffer = require('buffer').Buffer;

		// init @p2pmoney-org/ethereum_core
		let Ethereum_core = require('@p2pmoney-org/ethereum_core');
		const ethereum_core = Ethereum_core.getObject();
		const ethereum_core_init = await ethereum_core.init();

		// TODO: remove when controllers integrated into @p2pmoney-org/ethereum_core
		// put controllers class in common module
		let GlobalClass = window.simplestore.Global;
		let APIControllers = require('./@p2pmoney_ethereum_core/controller/controllers');

		GlobalClass.registerModuleClass('common', 'APIControllers', APIControllers);

		// put Ethereum_core in stored objects
		let client_global = GlobalClass.getGlobalObject();

		client_global.putGlobalStoredObject('Ethereum_core', Ethereum_core);

		return ethereum_core_init;
	}
	catch(e) {
		console.log('exception in p2pmoney_ethereum_core_load: ' + e);
	}
}

p2pmoney_ethereum_core_load()
.then( () => {
	console.log('@p2pmoney_ethereum_core loaded');

	// signal end of load
	let ScriptLoader = (window && window.simplestore && window.simplestore.ScriptLoader ? window.simplestore.ScriptLoader : null);

	if (ScriptLoader) {
		var rootscriptloader = ScriptLoader.getRootScriptLoader();
	
		rootscriptloader.signalEvent('on_p2pmoney_ethereum_core_load_end');
	}
})
.catch(err => {});
